<template>
  <div
    id="app"
    class="w-full h-full"
    :class="[
      infoOpen ? 'cross' : 'dot',
      forgroundColor ? 'text-white' : 'text-black'
    ]"
    :data-colour="colourIndex"
  >
    <Home />
    <CursorDot />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { bind } from "@/utils/eventListner";
import Home from "./components/Home.vue";
import CursorDot from "./components/CursorDot.vue";

export default {
  name: "App",

  components: {
    Home,
    CursorDot
  },

  data: () => ({
    colourIndex: 0
  }),

  computed: mapState(["infoOpen", "forgroundColor"]),

  created() {
    bind(
      window,
      "mouseup",
      () =>
        (this.colourIndex = this.colourIndex === 4 ? 0 : this.colourIndex + 1)
    );
  }
};
</script>

<style src="@/assets/css/app.css" />

<style scoped>
/* @import "./assets/css/app.css"; */

/* .dot,
.dot.text-white {
  cursor: url("~@/assets/images/dot.svg"), auto;
}

.dot.text-black {
  cursor: url("~@/assets/images/dot-black.svg"), auto;
} */

/* purgecss start ignore */
/* ::v-deep a {
  cursor: inherit;
} */
/* purgecss end ignore */

/* .cross {
  cursor: url("~@/assets/images/cross.svg"), auto;
} */
</style>
